module.exports = "/_next/static/images/SyncData@2x-266a65293c1e8e65025e650364da7af4.webp";